import {Box} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {useRef, type ReactElement, type ReactNode, useEffect} from 'react'
import {testIdProps} from '@github-ui/test-id-props'
// eslint-disable-next-line no-restricted-imports
import {iterateFocusableElements} from '@primer/behaviors/utils'

import type {NestedListItemMetadata} from './Metadata'
import styles from './MetadataContainer.module.css'
import clsx from 'clsx'

export interface MetadataContainerProps {
  sx?: BetterSystemStyleObject
  children: ReactNode | Array<ReactElement<typeof NestedListItemMetadata>>
  className?: string
}

export function NestedListItemMetadataContainer({sx, children, className}: MetadataContainerProps) {
  const metadataContainerRef = useRef(null)

  // Suppression of secondary info and actions
  // https://ui.githubapp.com/storybook/?path=/docs/recipes-nestedlistview-documentation-accessibility-listitem--docs#suppression-of-secondary-info-and-actions
  useEffect(() => {
    if (metadataContainerRef.current) {
      const elements = [...iterateFocusableElements(metadataContainerRef.current)]
      for (const el of elements) {
        el.tabIndex = -1
      }
    }
  }, [])

  return (
    <Box
      ref={metadataContainerRef}
      aria-hidden="true"
      sx={sx}
      {...testIdProps('nested-listview-item-metadata')}
      className={clsx(styles.MetadataContainer, className)}
    >
      {children}
    </Box>
  )
}

NestedListItemMetadataContainer.displayName = 'NestedListItemMetadataContainer'
